<script>
import { unitToDisplayText } from '@/layer/filters/units';
import StockService from '@/layer/services/stock';

export default {
  filters: {
    unitToDisplayText,
  },

  data: () => ({
    eggStock: [],
  }),

  methods: {
    quantityBoxes(stockItem) {
      let { boxes } = StockService.splitQuantityBoxesAndRemaining(stockItem.quantity, stockItem.type.quantity_per_box);
      return boxes;
    },
    quantityRemaining(stockItem) {
      let { remaining } = StockService.splitQuantityBoxesAndRemaining(stockItem.quantity, stockItem.type.quantity_per_box);
      return remaining;
    },
  },
}
</script>

<template>
  <div>

    <b-card class="mb-3">
      <h4 class="text-center"> Stock Balance </h4>

      <api-loader
        method="get"
        url="v1/layers/egg-stock"
        @loaded="eggStock=$event" />

      <table v-if="eggStock" class="table table-bordered table-sm">
        <thead>
          <th class="pl-3">Type</th>
          <th class="text-right pr-3" style="width:80px;">Boxes</th>
          <th class="text-right pr-3" style="width:80px;">Loose</th>
        </thead>
        <tr v-for="stockItem in eggStock" :key="stockItem.type.id">
          <td class="pl-3"> {{stockItem.type.type}} {{stockItem.type.unit | unitToDisplayText}} </td>
          <td class="text-right pr-3"> {{quantityBoxes(stockItem)}} </td>
          <td class="text-right pr-3"> {{quantityRemaining(stockItem)}} </td>
        </tr>
      </table>

    </b-card>

  </div>
</template>



// WEBPACK FOOTER //
// src/layer/components/EggStockBalance.vue